import { Download, FileText, Loader2, Coffee } from 'lucide-react';

export default function ExportBar({ templateLabel, isExporting, onExportPDF, onExportDocx }) {
  return (
    <div className="border-t border-stone-200 bg-white px-4 py-3 flex items-center justify-between gap-3 no-print">
      <div className="hidden md:block">
        <div className="tool-body text-[10px] uppercase tracking-[0.2em] text-stone-500">Currently</div>
        <div className="tool-display text-base text-stone-900">{templateLabel}</div>
      </div>
      <div className="flex gap-2 ml-auto">
        <a
          href="https://www.buymeacoffee.com/pixelutility"
          target="_blank"
          rel="noopener noreferrer"
          className="tool-body bg-[#FFDD00] hover:bg-[#e6c800] border border-[#FFDD00] text-black px-4 py-2.5 rounded text-sm font-medium flex items-center gap-2 transition-colors"
        >
          <Coffee className="w-4 h-4" />
          <span className="hidden sm:inline">Buy me a coffee</span>
        </a>
        <button
          onClick={onExportDocx}
          disabled={isExporting !== null}
          className="tool-body bg-white border border-stone-900 text-stone-900 hover:bg-stone-100 disabled:opacity-50 px-4 py-2.5 rounded text-sm font-medium flex items-center gap-2 transition-colors"
        >
          {isExporting === 'docx' ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileText className="w-4 h-4" />}
          Download Word
        </button>
        <button
          onClick={onExportPDF}
          disabled={isExporting !== null}
          className="tool-body bg-stone-900 hover:bg-stone-700 disabled:bg-stone-400 text-white px-4 py-2.5 rounded text-sm font-medium flex items-center gap-2 transition-colors"
        >
          {isExporting === 'pdf' ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
          Download PDF
        </button>
      </div>
    </div>
  );
}
